import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import chatImage from "../../assets/images/chat-img.png";
import CompanyLogosSlider from "../companyLogoSlider/companyLogoSlider";

const LearningSection = () => {

  return (
    <div className="learning-section overflow-hidden">
      <CompanyLogosSlider />
      <div className="container custom-container">
        <div className="d-flex flex-column flex-lg-row align-items-center mb-20 mb-sm-30 mb-md-44 gap-160 pb-20 pb-sm-30 pb-md-44">
          <div className="w-100 mb-16 mb-lg-0">
            <div className="text-center text-lg-start" data-aos="fade-right">
              <LazyLoadImage
                src={chatImage}
                alt="Learning Progress"
                className="img-fluid"
                effect="blur"
              />
            </div>
          </div>
          <div className="w-100">
            <h3
              className="fw-bold mb-15 mb-sm-25 mb-md-35 mb-lg-48 web-heading-01"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              Personalized Learning Paths Designed With EGWB
            </h3>
            <p
              className="fw-normal mb-15 mb-sm-25 mb-md-35 mb-lg-48"
              data-aos="fade-left"
              data-aos-delay="600"
            >
              Explore the beauty of nature with our latest guide. Discover
              breathtaking landscapes, vibrant ecosystems, and the tranquility
              that comes from immersing yourself in the great outdoors.
              Whether you're hiking through lush forests or relaxing by serene
              lakes, our guide will help you connect with the environment like
              never before.
            </p>
            <Link
              className="btn btn-primary btn-shadow-none"
              data-aos="fade-left"
              data-aos-delay="900"
            >
              Learn more
            </Link>
          </div>
        </div>
        <div className="d-flex flex-column flex-lg-row align-items-center mb-20 mb-sm-30 mb-md-40 mb-lg-50 gap-160">
          <div className="w-100 mb-16 mb-lg-0 order-lg-1">
            <div className="text-center text-lg-end" data-aos="fade-left">
              <LazyLoadImage
                src={chatImage}
                alt="Chat Practice"
                className="img-fluid"
                effect="blur"
              />
            </div>
          </div>
          <div className="w-100 order-lg-0">
            <h3
              className="fw-bold mb-15 mb-sm-25 mb-md-35 mb-lg-48 web-heading-01"
              data-aos="fade-right"
              data-aos-delay="300"
            >
              Engage In Authentic Dialogues To Enhance Your Fluency Skills.
            </h3>
            <p
              className="fw-normal mb-15 mb-sm-25 mb-md-35 mb-lg-48"
              data-aos="fade-right"
              data-aos-delay="600"
            >
              Explore the beauty of nature with our latest guide. Discover
              breathtaking landscapes, vibrant ecosystems, and the tranquility
              that comes from immersing yourself in the great outdoors.
              Whether you're hiking through lush forests or relaxing by serene
              lakes, our guide will help you connect with the environment like
              never before.
            </p>
            <Link
              className="btn btn-primary btn-shadow-none"
              data-aos="fade-right"
              data-aos-delay="900"
            >
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningSection;